import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConstantsService} from '../../fidelidade/ConstantsService';
import {WhatsappV4Service} from '../../services/whatsapp-v4.service';
import {EmpresasService} from '../../superadmin/services/empresas.service';

interface DispositivoWhatsappV4 {
  sessaoId: string;
  numeroWhatsappId: number;
  numero: string;
  dispositivoId: string;
  descricaoDispositivo: string;
  versaoExtensao: string;
  conectadaEm: string;
  ultimaAtividadeEm: string;
  whatsappConectado: boolean;
  livre: boolean;
  idMensagemEmAndamento: number;
  responsavelPelosEnvios: boolean;
}

@Component({
  selector: 'app-dispositivos-whatsapp',
  templateUrl: './dispositivos-whatsapp.component.html',
  styleUrls: ['./dispositivos-whatsapp.component.scss']
})
export class DispositivosWhatsappComponent implements OnInit {
  empresa: any;
  modoSuperadmin = false;
  dispositivos: DispositivoWhatsappV4[] = [];
  filtro = 'todos';
  busca = '';
  carregando = true;
  atualizando = false;
  erro = '';
  atualizadoEm: string;
  sessaoExpandidaId = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private constantsService: ConstantsService,
              private empresasService: EmpresasService,
              private whatsappV4Service: WhatsappV4Service) {}

  ngOnInit(): void {
    const idEmpresa = this.route.snapshot.params.idEmpresa;
    this.modoSuperadmin = !!idEmpresa;

    if (idEmpresa) {
      this.empresasService.obtenha(idEmpresa).then((resposta: any) => {
        this.definaEmpresa(resposta.data);
      });
      return;
    }

    this.constantsService.empresa$.subscribe((empresa: any) => {
      if (empresa && !this.empresa) {
        this.definaEmpresa(empresa);
      }
    });
  }

  get dispositivosFiltrados(): DispositivoWhatsappV4[] {
    const termo = this.busca.trim().toLowerCase();

    return this.dispositivos.filter((dispositivo) => {
      if (this.filtro !== 'todos' && this.estadoDo(dispositivo) !== this.filtro) {
        return false;
      }

      if (!termo) {
        return true;
      }

      return [
        dispositivo.descricaoDispositivo,
        dispositivo.numero,
        dispositivo.dispositivoId,
        dispositivo.versaoExtensao
      ].some((valor) => String(valor || '').toLowerCase().indexOf(termo) >= 0);
    });
  }

  get totalNumeros(): number {
    return new Set(this.dispositivos.map((dispositivo) => dispositivo.numeroWhatsappId)).size;
  }

  get totalEnviando(): number {
    return this.dispositivos.filter((dispositivo) => !!dispositivo.idMensagemEmAndamento).length;
  }

  get totalAtencao(): number {
    return this.dispositivos.filter((dispositivo) => this.estadoDo(dispositivo) === 'atencao').length;
  }

  carregue(forcarIndicador = false): void {
    if (!this.empresa || this.atualizando) {
      return;
    }

    this.atualizando = true;

    if (forcarIndicador) {
      this.erro = '';
    }

    this.whatsappV4Service.listeDispositivos(this.empresa).then((resposta: any) => {
      this.dispositivos = resposta.sessoes || [];
      this.atualizadoEm = resposta.atualizadoEm;
      this.erro = '';
    }).catch((erro) => {
      this.erro = String(erro || 'Não foi possível consultar os dispositivos conectados.');
    }).then(() => {
      this.carregando = false;
      this.atualizando = false;
    });
  }

  estadoDo(dispositivo: DispositivoWhatsappV4): string {
    if (dispositivo.idMensagemEmAndamento) {
      return 'enviando';
    }

    if (!dispositivo.whatsappConectado || !dispositivo.responsavelPelosEnvios) {
      return 'atencao';
    }

    return 'prontos';
  }

  rotuloDoEstado(dispositivo: DispositivoWhatsappV4): string {
    if (dispositivo.idMensagemEmAndamento) {
      return 'Enviando mensagem';
    }

    if (!dispositivo.whatsappConectado) {
      return 'WhatsApp desconectado';
    }

    if (!dispositivo.responsavelPelosEnvios) {
      return 'Outra conexão assumiu os envios';
    }

    return dispositivo.livre ? 'Pronto para enviar' : 'Processando';
  }

  alternarDetalhes(dispositivo: DispositivoWhatsappV4): void {
    this.sessaoExpandidaId = this.sessaoExpandidaId === dispositivo.sessaoId
      ? ''
      : dispositivo.sessaoId;
  }

  idResumido(dispositivo: DispositivoWhatsappV4): string {
    return String(dispositivo.dispositivoId || '').slice(0, 8).toUpperCase();
  }

  ultimoSinal(dispositivo: DispositivoWhatsappV4): string {
    const instante = new Date(dispositivo.ultimaAtividadeEm).getTime();
    const segundos = Math.max(0, Math.floor((Date.now() - instante) / 1000));

    if (segundos < 10) return 'agora';
    if (segundos < 60) return 'há ' + segundos + 's';
    return 'há ' + Math.floor(segundos / 60) + 'min';
  }

  identifiqueSessao(indice: number, dispositivo: DispositivoWhatsappV4): string {
    return dispositivo.sessaoId;
  }

  voltar(): void {
    const destino = this.modoSuperadmin
      ? '/superadmin/empresas/' + this.empresa.id
      : '/admin/loja';

    this.router.navigate([destino]).then(() => {});
  }

  private definaEmpresa(empresa: any): void {
    this.empresa = empresa;
    this.carregue();
  }
}
